module.exports = __webpack_public_path__ + "img/sld_acdb_mfm_lt_panel_t1_b1.a5c02c4f.svg";